import { referenceRegex } from 'consts/referenceRegex'

import { getHtmlStringForDocx } from './getHtmlStringForDocx'
import { getHtmlStringFromMarkdown } from './getHtmlStringFromMarkdown'
import { wrapLooseReferenceSups } from './wrapLooseReferenceSups'

import type { GetSanitizedContentWithCustomElementsInput } from 'types/GetSanitizedContentWithCustomElementsInput'

const inlineReferenceRegex = /\[inline=(\w+)\]/g
const detailsSummaryRegex = /<details><summary>(.*?)<\/summary><RiskIndicator variant=".*?">(.*?)<\/RiskIndicator>/g

export const addCustomElements = ({
  assignReferenceIndex,
  markdownContent,
  messageId,
  outputFormat = 'screen',
}: GetSanitizedContentWithCustomElementsInput) => {
  if (!markdownContent) return ''

  const convertReferences = (_: string, referenceId: string) => {
    const referenceNumber = assignReferenceIndex?.(messageId, referenceId) || ''

    if (outputFormat === 'plain_text') {
      return `[${referenceNumber}] `
    }

    if (outputFormat === 'clipboard' || outputFormat === 'docx') {
      return `<sup>${referenceNumber}</sup> `
    }

    return `<InlineReference referenceId="${referenceId}" messageId="${messageId}" referenceNumber="${referenceNumber}" />`
  }

  const processedContentForDetails = outputFormat === 'plain_text' || outputFormat === 'docx'
    ? markdownContent.replace(
        detailsSummaryRegex,
        (_, summary: string, riskText: string) => `## ${summary} (${riskText})`,
      ).replace(/<\/details>/g, '')
    : markdownContent

  const processedContentForReferences = processedContentForDetails.replace(referenceRegex, convertReferences)

  const processedContentForInlineReferences = processedContentForReferences.replace(inlineReferenceRegex, convertReferences)

  if (outputFormat === 'docx') {
    return wrapLooseReferenceSups(
      getHtmlStringForDocx(processedContentForInlineReferences),
    )
  }

  if (outputFormat === 'clipboard') {
    return getHtmlStringFromMarkdown(processedContentForInlineReferences, messageId)
  }

  return processedContentForInlineReferences
}
